
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
// import { auth } from '../../helpers/Firebase';
import API, { auth, apikey } from '../../constants/api';
import {
    LOGIN_USER,
    // REGISTER_USER,
    LOGOUT_USER
} from '../actions';

import {
    loginUserSuccess,
    loginUserError
} from './actions';

const loginWithEmailPasswordAsync = async (email, password) =>
    await API.post('user/login', {
      user_username: email,
      user_password: password
    }, {
      headers : {
        'Content-Type': 'application/json',
        'apikey': apikey
      }
    })
        .then(authUser => authUser)
        .catch(error => error);

function* loginWithEmailPassword({ payload }) {
    const { email, password } = payload.user;
    const { history } = payload;
    try {
        const loginUser = yield call(loginWithEmailPasswordAsync, email, password);
        if (loginUser.data.StatusCode === "0000") {
            localStorage.setItem('user_id', JSON.stringify(loginUser.data.ResultValues));
            yield put(loginUserSuccess(loginUser.data.ResultValues));
            history.push(payload.desiredPath);
        } else {
            yield put(loginUserError(loginUser.data.Message));
        }
    } catch (error) {
        yield put(loginUserError(error));

    }
}

// const registerWithEmailPasswordAsync = async (email, password) =>
//     await auth.createUserWithEmailAndPassword(email, password)
//         .then(authUser => authUser)
//         .catch(error => error);
//
// function* registerWithEmailPassword({ payload }) {
//     const { email, password } = payload.user;
//     const { history } = payload
//     try {
//         const registerUser = yield call(registerWithEmailPasswordAsync, email, password);
//         if (!registerUser.message) {
//             localStorage.setItem('user_id', registerUser.user.uid);
//             yield put(registerUserSuccess(registerUser));
//             history.push('/')
//         } else {
//             yield put(registerUserError(registerUser.message));
//
//         }
//     } catch (error) {
//         yield put(registerUserError(error));
//     }
// }



const logoutAsync = async (history) => {
    await auth.signOut().then(authUser => authUser).catch(error => error);
    history.push('/')
}

function* logout({ payload }) {
    const { history } = payload
    try {
        yield call(logoutAsync, history);
        localStorage.removeItem('user_id');
    } catch (error) {
    }
}



// export function* watchRegisterUser() {
//     yield takeEvery(REGISTER_USER, registerWithEmailPassword);
// }

export function* watchLoginUser() {
    yield takeEvery(LOGIN_USER, loginWithEmailPassword);
}

export function* watchLogoutUser() {
    yield takeEvery(LOGOUT_USER, logout);
}


export default function* rootSaga() {
    yield all([
        fork(watchLoginUser),
        fork(watchLogoutUser),
        // fork(watchRegisterUser)
    ]);
}
